// import APIs
import { CRON_JOBS } from 'RestAPIs/endpoints';

// import components
import { showSnackbar } from 'components/shared';
import showError from 'components/shared/showError';

// import external libraries
import axios, { AxiosError, AxiosResponse } from 'axios';
import i18n from 'i18next';
import { useMutation, useQueryClient } from 'react-query';

// import types
import { CronJob } from '../CronJobsCRUDForm.types';

export const useChangeRunStatus = () => {
  const queryClient = useQueryClient();

  return useMutation<AxiosResponse, AxiosError, any>({
    mutationFn: ({ id, row }: { id: number; row: CronJob }) =>
      axios.put(`${CRON_JOBS}/${row?.group}/${id}`, {
        method: row.state === 'PAUSED' ? 'resume' : 'pause'
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['cron-jobs', 'list']
      });
      showSnackbar({
        severity: 'success',
        message: i18n.t('changesSaved')
      });
    },
    onError: (error) => {
      showError(error);
    }
  });
};
